












































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Category from "../../../store/entities/category";
import _ from "lodash";
@Component
export default class EditCategory extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  category: Category = new Category();
  created() {}
  isClient() {
    return !_.isNil(this.$store.state.session.client);
  }
  get parentCategories() {
    var editCategoryId = this.category.id;
    var list = _.filter(
      this.$store.state.category.parentCategoriesForSelect,
      function(i) {
        return i.id != editCategoryId;
      }
    );
    return list;
  }
  save() {
    (this.$refs.categoryForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store
          .dispatch({
            type: "category/update",
            data: this.category,
          })
          .then(async () => {
            await this.$store.dispatch({
              type: "category/getParentListForSelect",
              data: {
                isMaster: !this.isClient(),
              },
            });
            (this.$refs.categoryForm as any).resetFields();
            this.$emit("save-success");
            this.$emit("input", false);
          });
      }
    });
  }
  cancel() {
    (this.$refs.categoryForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.category = Util.extend(
        true,
        {},
        this.$store.state.category.editCategory
      );
    }
  }
  categoryRule = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
  };
}
